export const Black = "#000000"
export const White = "#fff"
export const White_32 = "rGBa(255,255,255,.32)"
export const Gray_100 = "#F5F6F8"
export const Gray_150 = "#EBEDF0"
export const Gray_200 = "#E5E8EB"
export const Gray_300 = "#D2D6DD"
export const Gray_400 = "#B9C0CA"
export const Gray_500 = "#9AA5B3"
export const Gray_600 = "#7C899B"
export const Gray_700 = "#5E6F85"
export const Gray_800 = "#354A66"
export const Gray_900 = "#031D40"
export const Gray_Dark = "#414953"
export const Blue_50 =	 "#F5F9FF"
export const Blue_100 = "#ECF3FE"
export const Blue_200 = "#D8E8FD"
export const Blue_300 = "#C0DAFC"
export const Blue_400 = "#8ABAFA"
export const Blue_500 = "#5097F7"
export const Blue_600 =  "#0B6EF4"
export const Blue_800 = "#063E88"
export const Blue_900 = "#031D40"
export const Blue = "#095ac3"
export const Indigo = "#031d40"
export const Purple = "#6f42c1"
export const Pink = "#e83e8c"
export const Red = "#CD0A0A"
export const Orange = "#fD7e14"
export const Yellow = "#ffc31f"
export const Green = "#167f06"
export const Teal = "#20c997"
export const Cyan = "#17a2b8"
export const Bluegray = "#063e88"
export const Primary = Indigo
export const Secondary = Blue
export const BorderColor = Gray_300



